import { Controller } from "@hotwired/stimulus";

/**
 * Mobile Toggle Controller
 * Alternativa al core menu-button cuando el nav está fuera del scope del botón.
 * Togglea clases y atributos en el nav usando un selector directo por ID.
 *
 * Uso: data-controller="mobile-toggle" (no necesita data-action)
 */
export default class extends Controller {
	static values = {
		menuId: { type: String, default: "header-nav" },
		closeText: { type: String, default: "Cerrar" },
		openText: { type: String, default: "Menu" },
	};

	connect() {
		this.isOpen = false;
		this.element.addEventListener("click", (e) => this.toggle(e));
	}

	toggle(event) {
		event.preventDefault();
		this.isOpen = !this.isOpen;

		const nav = document.getElementById(this.menuIdValue);
		if (!nav) return;

		this.element.setAttribute("aria-expanded", String(this.isOpen));
		nav.classList.toggle("open", this.isOpen);
		nav.setAttribute("aria-hidden", String(!this.isOpen));
		document.body.classList.toggle("no-scroll", this.isOpen);
		document.querySelector("header")?.classList.toggle("open", this.isOpen);

		const label = this.element.querySelector(".menu-label");
		if (label) {
			label.textContent = this.isOpen
				? this.closeTextValue
				: this.openTextValue;
		}
	}
}
